import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptService {

  private encryptKey = environment.encryptKey;

  encrypt = (txt: string) => CryptoJS.AES.encrypt(txt, this.encryptKey).toString();

  decrypt = (txtToDecrypt: string) => CryptoJS.AES.decrypt(txtToDecrypt, this.encryptKey).toString(CryptoJS.enc.Utf8);


}
